module.exports = __webpack_public_path__ + "img/how_to_come_up_with_game_ideas_splash.11329684.jpg";